import React, { useState, useEffect } from 'react';
import { Button, Card, Alert, Form, Modal, Spinner } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import Section from 'components/common/Section';
import api from 'helpers/api';
import { getNivelUsuario } from 'helpers/auth';

const Contacts = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [titleModal,setTitleModal ] = useState('');
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [editingContactId, setEditingContactId] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (getNivelUsuario() === null || getNivelUsuario() !== "3") {
            window.location.href = '/';
        }

        const getContacts = async () => {
            setIsLoading(true);
            const result = await api.get('/api/contacts/');
            setData(result.data.result);
            setIsLoading(false);
        };

        getContacts();
    }, []);

    useEffect(() => {
        const newFilteredData = data.filter(item =>
            (item.usu_nome && item.usu_nome.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (item.usu_email && item.usu_email.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        setFilteredData(newFilteredData);
    }, [data, searchTerm]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!nome || !email) {
            setError('Informe Nome e E-mail');
            return;
        }

        try {
            if (editingContactId) {
                // Atualiza o contato existente
                const response = await api.put(`/api/contacts/${editingContactId}`, { nome, email });
                setMessage('Contato atualizado com sucesso!');
            } else {
                // Cadastra um novo contato
                const response = await api.post(`/api/novo-contato`, { nome, email });
                setMessage(response.data.message);
            }
            setShowModal(false);
            setNome('');
            setEmail('');
            setEditingContactId(null); // Reseta o ID após a operação
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao salvar o contato.');
        }
    };

    const openEditModal = (contact) => {
        setTitleModal("Alterar Senha")
        setNome(contact.usu_nome);
        setEmail(contact.usu_email);
        setEditingContactId(contact.id);
        setShowModal(true);
    };

    const openNewModal = () => {
        setTitleModal("Cadastrar Novo Usuário")
        setNome("");
        setEmail("");
        setEditingContactId(null);
        setShowModal(true);
    };


    const toggleActive = async (userId) => {
        setData(data.map(user =>
            user.id === userId ? { ...user, active: !user.active } : user
        ));
    };

    const columns = [
        {
            accessor: 'usu_nome',
            Header: 'Nome',
            headerProps: { className: 'fw-medium pe-2 text-900' },
            cellProps: { className: 'py-2' }
        },
        {
            accessor: 'usu_email',
            Header: 'E-mail',
            headerProps: { className: 'fw-medium pe-2 text-900' },
            cellProps: { className: 'py-3' }
        },
        // {
        //     accessor: 'actions',
        //     Header: 'Ações',
        //     Cell: ({ row }) => (
        //         <>
        //             <Button variant="secondary" onClick={() => openEditModal(row.original)}>
        //                 Alterar Senha
        //             </Button>
        //             {/* <Button variant="secondary" onClick={() => toggleActive(row.original.id)}>
        //                 {row.original.active ? 'Inativar' : 'Ativar'}
        //             </Button> */}
        //         </>
        //     ),
        //     headerProps: { className: 'fw-medium pe-2 text-900' }
        // }
    ];

    return (
        <>
            {isLoading ? (
                <div className="p-2 text-center">
                    <Spinner animation="border" />
                    <span> Aguarde carregando ...</span>
                </div>
            ) : (
                <AdvanceTableWrapper
                    columns={columns}
                    data={filteredData}
                    sortable
                    pagination
                    perPage={20}
                    tableProps={{ size: 'xs', striped: true }}
                >
                    <Card className="mb-3">
                        <Card.Header>
                            <Button className="me-1 mb-1" size="sm" onClick={() => openNewModal()}>
                                Novo Usuário
                            </Button>
                            <Form.Control
                                type="text"
                                placeholder="Pesquisar..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="mb-2"
                            />
                        </Card.Header>
                        <Card.Body>
                            <AdvanceTable
                                table
                                headerClassName="bg-200 text-nowrap align-middle"
                                rowClassName="align-middle"
                            />
                        </Card.Body>
                        <Card.Footer>
                            <AdvanceTableFooter
                                rowCount={filteredData.length}
                                table
                                canPreviousPage
                                navButtons
                                rowsPerPageSelection
                            />
                        </Card.Footer>
                    </Card>

                    <Modal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>{titleModal}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Section className="py-0">
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Nome"
                                            value={nome}
                                            onChange={(e) => setNome(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="E-mail"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </Form.Group>
                                    <Button variant="primary" type="submit">
                                        Salvar
                                    </Button>
                                </Form>

                                {message && <Alert variant="success" className="mt-3">{message}</Alert>}
                                {error && <Alert variant="primary" className="mt-3">{error}</Alert>}
                            </Section>
                        </Modal.Body>
                    </Modal>
                </AdvanceTableWrapper>
            )}
        </>
    );
};

export default Contacts;